// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mMFp","largestCol":"styles_largestCol__35d69","smallestCol":"styles_smallestCol__2LW9F"};